export default class BaseEndpoint {
    /**
     * @type {AxiosInstance}
     * @private
     */
    _instance;
    
    /**
     * @type {string}
     * @private
     */
    csrfToken;

    static instance() {
        if (this._instance === undefined) {
            this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

            this._instance = axios.create({
                baseURL: '/api/v1',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-CSRF-TOKEN': this.csrfToken
                }
            });
        }
        return this._instance;
    }
}